export default __webpack_public_path__ + "static/media/Heissluftballon-mit-Maus.240a1903.png";